var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.agentDataLoadingStatus == 'loaded' && _vm.userDataListLoadingStatus == 'loaded')?_c('v-breadcrumbs',{attrs:{"items":_vm.breadcrumbs},scopedSlots:_vm._u([{key:"item",fn:function(ref){
var item = ref.item;
var index = ref.index;
return [_c('v-breadcrumbs-item',{attrs:{"to":item.href,"disabled":item.disabled,"exact":(index==0) ? true : false}},[_vm._v("\n      "+_vm._s(item.text)+"\n    ")])]}}],null,false,4193307702)}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }